import { LoginCallbackScreen } from "@modules/auth/screens/LoginCallbackScreen";
import { LoginScreen } from "@modules/auth/screens/LoginScreen";
import { TenantScreen } from "@modules/auth/screens/TenantScreen";
import { AppRoute } from "interfaces/router.interface";

// The routes
const CustomRoutes: AppRoute[] = [
  {
    path: "login",
    element: <LoginScreen />,
  },
  {
    path: "tenants",
    element: <TenantScreen />,
  },
  {
    path: "callback",
    element: <LoginCallbackScreen />,
  },
];

export default CustomRoutes;
